import React, { useEffect } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./style.css";
import { useLocation } from "react-router-dom";

import gardenPavingDesingnVancouver from "../../assets/img/garden-paving-design-north-vancouver.jpeg";
import chaferBeetleLawnDamage from "../../assets/img/chafer-beetle-lawn-damage-repair-vancouver.jpg";
import backyardBeehiveVancouver from "../../assets/img/backyard-beehive-vancouver-pollination.png";
import familyLawnCareServices from "../../assets/img/family-lawn-care-services-vancouver.jpg";
import lawnCareProfessionalLimeTreatment from "../../assets/img/lawn-care-professional-lime-treatment.jpg";
import pollinatorFriendlyFlowerGarden from "../../assets/img/pollinator-friendly-flower-garden-vancouver.jpg";
import cuttingPerennialsVancouver from "../../assets/img/cutting-perennials-vancouver.jpg";
import properGardenWatering from "../../assets/img/proper-garden-watering-techniques-vancouver.png";
import handPickingBlackberries from "../../assets/img/hand-picking-blackberries-vancouver.jpg";
import yellowDaffodilsSnow from "../../assets/img/yellow-daffodils-snow-vancouver.jpg";
import mulchAndSoil from "../../assets/img/bark-mulch-for-garden.png";
import fallPath from "../../assets/img/fall-path.jpeg";
import snow from "../../assets/img/snow.jpg";
import allanBlock from "../../assets/img/allan-block-stone-retaining-wall-design.jpg";
import finishedPatioPavers from "../../assets/img/finished-patio-pavers-pathway.jpeg";
import lawnMowingService from "../../assets/img/lawn-mowing-service-residential-yard.jpeg";
import lawnDisease from "../../assets/img/lawn-disease-close-up-damaged-grass.jpg";
import lawn from "../../assets/img/urban-planter-with-ornamental-grasses.jpg";
import raisedGarden from "../../assets/img/raised-garden-beds-with-irrigation.jpg";
import modernPatio from "../../assets/img/modern-patio-landscape-west-vancouver.jpg";
import lawnAeration from "../../assets/img/lawn-aeration-equipment-burhan.jpg";
import imgLogo from "../../assets/img/bur-hanBadge.png";
import FertilizerBag from "../../assets/img/professional-fertilizer-bag-23-3-23.jpg.jpg";
import BhYard from "../../assets/img/bh-backyard-garden-lawn-design-vancouver.jpg";
import ElectricMowerLawn from "../../assets/img/electric-mower-cutting-lawn.jpg";
import StrataProperty from "../../assets/img/strata-property.jpeg";
import imgcommingsoon from "../../assets/img/blog-coming-soon.png";
import BHElectric from "../../assets/img/electric-trimmer.jpg";
import mastering from "../../assets/img/freshly-mowed-lawn-bur-han.jpg";
import ultimateGuide from "../../assets/img/backyard-sod-installation-north-vancouver-after.jpg";
import sunkenconcrete from "../../assets/img/sunken-concrete.jpeg";
import paver from "../../assets/img/projects/pavingStone/custom-circular-paving-stone-patio.jpg";
import weeklycutting from "../../assets/img/freshly-mowed-lawn-with-landscaping-truck.jpg";
import pelletizedCompost from "../../assets/img/pelletized-compost.jpg";
import flourishingGarden from "../../assets/img/flourishingGarden1.jpg";
import lawnWatering from "../../assets/img/greenLawn.jpg";
import indoorPlants from "../../assets/img/hanging-flower-baskets-greenhouse-vancouver.jpeg";
import ecofriendly from "../../assets/img/lawn-health.jpg";
import lawnWinter from '../../assets/img/vancouver-garden-light-snow-dusting.jpg';
import fertilizerSpreader from "../../assets/img/lawn-maintenance-fertilizer-spreader.jpg";
import syntheticFertilizer from "../../assets/img/synthetic-fertilizer-in-hand.jpg";
import chaferGrubs from "../../assets/img/chafer-beetle-grubs-hand.jpg";

export default function Blog() {
  const location = useLocation();

  // Meta Tag changes
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "Landscaping & Lawn Care Blog | Vancouver Tips & Guides";
    document.title = newTitle;

    const newDescription =
      "Explore BUR-HAN's blog for expert landscaping & lawn care tips in Vancouver. Find guides on garden maintenance, design ideas, pest control, and sustainable outdoor practices.";
    const descriptionMetaTag = document.querySelector(
      'meta[name="description"]'
    );
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
      "landscaping tips Vancouver,lawn care tips North Vancouver, organic gardening BC, outdoor living ideas Vancouver, garden maintenance tips, seasonal lawn care tips, sustainable landscaping ideas, pest control tips Vancouver, fertilizer guide for lawns, hardscaping ideas North Vancouver, natural fertilizers for healthy soil, bee-friendly gardens Vancouver, chafer beetle control Vancouver, spring garden preparation BC, fall leaf cleanup tips, water-efficient landscaping solutions, modern garden paving ideas, family lawn care services, pollinator-friendly garden designs, blackberry removal guide Vancouver,Learn about sustainable landscaping ideas to create a bee-friendly garden in Vancouver.",
    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector(
      'meta[property="og:description"]'
    );
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="blogHeader">
        <h1 data-aos="zoom-in"> Blog</h1>
      </div>
      <div className="blogMain" data-aos="fade-up">
        <h2 data-aos="fade-down">
          Welcome to BUR-HAN's blog for expert tips on landscaping, lawn care,
          and gardening.
        </h2>
        <hr />
        <div className="container">
          <section className="featured-posts">
            <div className="cardBlog-columns listfeaturedtag">

              <div className="cardBlog" data-aos="fade-up">
                <a href="/blog/organic-vs-synthetic-fertilizer-vancouver" aria-label="organic-vs-synthetic-fertilizer">
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${syntheticFertilizer})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Organic vs Synthetic Fertilizer: What's Best for Vancouver Lawns?
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Lawn Care</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a href="/blog/how-to-fix-chafer-beetle-lawn-damage" aria-label="fix-chafer-beetle-damage">
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${chaferGrubs})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          How to Fix Chafer Beetle Lawn Damage: A Step-by-Step Repair Guide
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Lawn Care</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a href="/blog/how-often-mow-lawn-vancouver" aria-label="how-often-mow-lawn-vancouver">
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${mastering})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          How Often Should You Mow Your Lawn in Vancouver? A Season-by-Season Guide
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Lawn Care</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a href="/blog/spring-lawn-care-checklist-vancouver" aria-label="spring-lawn-care-checklist-vancouver">
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${lawnAeration})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Spring Lawn Care Checklist for Greater Vancouver Homeowners
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Lawn Care</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a href="/blog/moss-control-vancouver-lawns" aria-label="moss-control-vancouver-lawns">
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${ecofriendly})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Moss Control in Vancouver Lawns: Causes, Treatment &amp; Long-Term Prevention
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Lawn Care</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a href="/blog/when-to-fertilize-lawn-vancouver" aria-label="when-to-fertilize-lawn-vancouver">
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${fertilizerSpreader})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          When to Fertilize Your Lawn in Vancouver: A Season-by-Season Schedule
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Lawn Care</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a href="/blog/how-to-prepare-your-lawn-for-winter" aria-label="dykhof-nurseries">
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${lawnWinter})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          How to Prepare Your Lawn for Winter
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              
<div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/eco-friendly-lawn-care"
                  aria-label="eco friendly lawn care"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{ backgroundImage: `url(${ecofriendly})` }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Eco Friendly Lawn Care{" "}
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN logo"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/how-to-keep-your-vancouver-lawn-green"
                  aria-label=""
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${lawnWatering})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          How to Keep Your Vancouver Lawn Green with Once-a-Week
                          Watering{" "}
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/weekly-lawn-cutting-service-in-vancouver-surrounding-areas"
                  aria-label="Weekly Lawn Cutting Service in Vancouver & Surrounding Areas
"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${weeklycutting})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Weekly Lawn Cutting Service in Vancouver & Surrounding
                          Areas
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a href="/blog/dykhof-nurseries" aria-label="dykhof-nurseries">
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${indoorPlants})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Dykhof Nurseries: A North Vancouver Legacy Since 1957{" "}
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/the-secret-to-a-flourishing-flower-garden"
                  aria-label=""
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${flourishingGarden})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          The Secret To A Flourishing Flower Garden
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/soil-health-lawn-vancouver-compost-service"
                  aria-label=""
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${pelletizedCompost})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Compost vs. Topsoil: Lawn Health in Vancouver
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/best-repair-options-for-sunken-concrete-walkways"
                  aria-label="What is your Best Options When You Have a Sunken Concrete Walkway
"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{ backgroundImage: `url(${sunkenconcrete})` }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          What is your Best Options When You Have a Sunken
                          Concrete Walkway
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c2">hardscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN logo"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/why-electric-lawn-care-benefits-strata-properties-in-vancouver"
                  aria-label="Why Electric Lawn Care Benefits Strata Properties in Vancouver"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{ backgroundImage: `url(${StrataProperty})` }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Why Electrification of Landscaping Equipment Matters
                          for Residential Strata
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN logo"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/mastering-the-art-of-lawn-mowing-tips-for-a-healthy-vibrant-lawn"
                  aria-label="Mastering the Art of Lawn Mowing: Tips for a Healthy, Vibrant Lawn"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{ backgroundImage: `url(${mastering})` }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Mastering the Art of Lawn Mowing: Tips for a Healthy,
                          Vibrant Lawn
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN logo"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/spring-garden-cleanup-guide-for-greater-vancouver"
                  aria-label="Spring Garden Cleanup Guide for Greater Vancouver"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${BhYard})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Spring Garden Cleanup Guide for Greater Vancouver
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/aerating-your-lawn-how-to-do-it-right-in-vancouver"
                  aria-label="Aerating Your Lawn: Why, When, and How to Do It Right in Vancouver"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${lawnAeration})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Aerating Your Lawn: Why, When, and How to Do It Right
                          in Vancouver
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/creating-your-outdoor-living-space-in-vancouver"
                  aria-label="Creating Your Outdoor Living Space in Vancouver"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${modernPatio})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Creating Your Outdoor Living Space in Vancouver
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c2">hardscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/sustainable-landscaping-a-vision-for-north-and-west-vancouver"
                  aria-label="Sustainable Landscaping: A Vision for North and West Vancouver"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${lawn})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Sustainable Landscaping: A Vision for North and West
                          Vancouver
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/red-thread-causes-fixes-and-spring-prevention-tips"
                  aria-label="Red Thread: Causes, Fixes, and Spring Prevention Tips"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${lawnDisease})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Red Thread: Causes, Fixes, and Spring Prevention Tips
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/expert-walkway-installation-in-greater-vancouver-a-complete-guide"
                  aria-label="Expert Walkway Installation in Greater Vancouver - A Complete Guide"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${finishedPatioPavers})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Expert Walkway Installation in Greater Vancouver - A
                          Complete Guide
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c2">hardscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/walkway-installation-services-enhance-your-property"
                  aria-label="walkway installation services enhance your property"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${paver})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Walkway Installation
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c2">hardscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/the-benefits-of-a-professional-lawn-cutting-service-in-vancouver"
                  aria-label=""
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{ backgroundImage: `url(${ElectricMowerLawn})` }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          The Benefits of a Professional Lawn Cutting Service{" "}
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN logo"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/the-ultimate-guide-to-watering-new-turfgrass-sod"
                  aria-label="The Ultimate Guide to Watering New Turfgrass Sod"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{ backgroundImage: `url(${ultimateGuide})` }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          The Ultimate Guide to Watering New Turfgrass Sod
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN logo"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/bur-han-goes-all-electric!-here's-why-it-matters"
                  aria-label="BUR-HAN Goes All-Electric! Here's Why It Matters"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{ backgroundImage: `url(${BHElectric})` }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          BUR-HAN Goes All-Electric! Here's Why It Matters{" "}
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN logo"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/how-to-read-a-fertilizer-label-and-apply-it-to-your-lawn"
                  aria-label="How to Read a Fertilizer Label and Apply it to Your Lawn"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${FertilizerBag})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          How to Read a Fertilizer Label and Apply it to Your
                          Lawn
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/cedar-timber-raised-garden-beds-a-durable-and-safe-choice"
                  aria-label="Cedar Timber Raised Garden Beds: A Durable and Safe Choice"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${raisedGarden})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Cedar Timber Raised Garden Beds: A Durable and Safe
                          Choice
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c2">hardscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/spring-lawn-and-garden-tips-for-a-healthy-yard"
                  aria-label="Spring Lawn and Garden Tips for a Healthy Yard"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${lawnMowingService})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Spring Lawn and Garden Tips for a Healthy Yard
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/replacing-a-timber-wall-with-an-allan-block-wall"
                  aria-label="Replacing a Timber Wall with an Allan Block Wall: A Smart Investment for Longevity"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${allanBlock})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Replacing a Timber Wall with an Allan Block Wall:
                          Investing in Durability
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c2">hardscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-up">
                <a
                  href="/blog/understanding-the-power-of-soils-and-mulch-in-gardening"
                  aria-label="Understanding the Power of Soils and Mulch in Gardening"
                >
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{ backgroundImage: `url(${mulchAndSoil})` }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Understanding the Power of Soils and Mulch in
                          Gardening
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN logo"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
               <div className="cardBlog" data-aos="fade-up">
                <a href="/blog" aria-label="dykhof-nurseries">
                  <div className="row">
                    <div className="col-5 wrapthumbnail">
                      <div
                        className="thumbnail"
                        style={{
                          backgroundImage: `url(${imgcommingsoon})`,
                        }}
                      ></div>
                    </div>
                    <div className="col-7">
                      <div className="cardBlog-block">
                        <h2 className="cardBlog-title mll">
                          Coming Soon
                        </h2>
                        <div className="metafooter">
                          <div className="tagColor c1">Landscaping</div>
                          <div className="wrapfooter">
                            <span className="meta-footer-thumb">
                              <img loading="lazy"
                                className="author-thumb"
                                src={imgLogo}
                                alt="BUR-HAN spring"
                              />
                            </span>
                            <span className="author-meta">
                              <span className="post-name">
                                By The Bur-Han Team
                              </span>
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

            </div>
          </section>
          <section className="recentBlog-posts">
            <div className="sectionBlog-title">
              <h2>
                <span data-aos="fade-up">More Blog Posts</span>
              </h2>
            </div>
            <div className="cardBlog-columns listrecent">
              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/snow-and-ice-management-tips-for-north-and-west-vancouver-homeowners"
                  aria-label="Snow and Ice Management Tips For North And West Vancouver Homeowners"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={snow}
                    alt="Hand-picking ripe blackberries in a Vancouver garden"
                    title="Blackberry Harvesting Tips for Vancouver Gardens"
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      Snow and Ice Management
                      <br />
                      <br />
                      <br />
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/the-essential-guide-to-blackberry-removal-in-greater-vancouver"
                  aria-label="The Essential Guide to Blackberry Removal in Greater Vancouver"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={handPickingBlackberries}
                    alt="Hand-picking ripe blackberries in a Vancouver garden"
                    title="Blackberry Harvesting Tips for Vancouver Gardens"
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      The Essential Guide to Blackberry Removal in Greater
                      Vancouver{" "}
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/creating-a-pollinator-and-native-plant-garden"
                  aria-label="Creating a Pollinator and Native Plant Garden"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={pollinatorFriendlyFlowerGarden}
                    alt="Vibrant pollinator-friendly flower garden with pink, blue, and yellow blooms in Vancouver."
                    title="Pollinator-Friendly Flower Gardens in Vancouver "
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      Creating a Pollinator and Native Plant Garden
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/responsible-lawn-watering-in-vancouver"
                  aria-label="Responsible Lawn Watering in Vancouver"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={properGardenWatering}
                    alt="Watering a vegetable garden with precision for healthy growth in Vancouver"
                    title="Proper Garden Watering Techniques for Healthy Plants in Vancouver "
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      Responsible Lawn Watering in Vancouver
                      <br />
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/cutting-back-perennials-in-vancouver-a-gardener's-guide"
                  aria-label="Cutting Back Perennials in Vancouver: A Gardener's Guide"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={cuttingPerennialsVancouver}
                    alt="Hand-picking ripe blackberries in a Vancouver garden"
                    title="Blackberry Harvesting Tips for Vancouver Gardens"
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      Cutting Back Perennials in Vancouver: A Gardener's Guide
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/the-importance-of-a-fall-leaf-cleanup"
                  aria-label="The Importance Of A Fall Leaf Cleanup"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={fallPath}
                    alt=" Dog walking on a fall trail with colorful foliage and fallen leaves."
                    title="Scenic Fall Trail with Dog Walking "
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      The Importance Of A Fall Leaf Cleanup
                      <br />
                      <br />
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/garden-maintenance-guide"
                  aria-label="Garden Maintenance Guide - SPRING"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={familyLawnCareServices}
                    alt="Family enjoying a well-maintained backyard with professional lawn care services in Vancouver."
                    title="Family-Friendly Lawn Care Services in Vancouver by BUR-HAN Garden & Lawn Care"
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      Garden Maintenance Guide - SPRING
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a href="/blog/chafer-beetle" aria-label="The Chafer Beetle">
                  <img loading="lazy"
                    className="img-fluid"
                    src={chaferBeetleLawnDamage}
                    alt="Chafer beetle damage on a lawn being inspected and repaired in Vancouver by BUR-HAN Garden & Lawn Care."
                    title="Expert Chafer Beetle Lawn Damage Repair Services in Vancouver"
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      The Chafer Beetle <br />
                      <br />
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/late-fall-gardening-bulbs-to-remove-and-plant-in-november-and-december"
                  aria-label="Late Fall Gardening: Bulbs to Remove and Plant in November and December"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={yellowDaffodilsSnow}
                    alt="Hand-picking ripe blackberries in a Vancouver garden"
                    title="Blackberry Harvesting Tips for Vancouver Gardens"
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      Late Fall Gardening: Bulbs to Remove and Plant in November
                      and December
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/the-essential-guide-to-lawn-fertilization"
                  aria-label="The Essential Guide to Lawn Fertilization"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={lawnCareProfessionalLimeTreatment}
                    alt="A lawn care professional applying lime treatment on a vibrant green lawn in Vancouver."
                    title="Professional Lawn Lime Treatment Services in Vancouver "
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      The Essential Guide to Lawn Fertilization
                      <br />
                      <br />
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a
                  href="/blog/paving-stone-quality-and-value"
                  aria-label="Paving Stone - Quality and Value"
                >
                  <img loading="lazy"
                    className="img-fluid"
                    src={gardenPavingDesingnVancouver}
                    alt="Modern garden with elegant paving and lush greenery designed by BUR-HAN Garden & Lawn Care in North Vancouver."
                    title="Modern Garden Paving and Landscape Design Services in North Vancouver"
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      Paving Stone - Quality and Value
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c2">hardscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="cardBlog" data-aos="fade-left">
                <a href="/blog/saving-the-bees" aria-label="Saving the Bees">
                  <img loading="lazy"
                    className="img-fluid"
                    src={backyardBeehiveVancouver}
                    alt="A backyard beehive for sustainable pollination and biodiversity in Vancouver, BC."
                    title="Sustainable Backyard Beekeeping for Pollination in Vancouver"
                  />
                  <div className="cardBlog-block">
                    <h2 className="cardBlog-title">
                      Saving the Bees
                      <br />
                      <br />
                    </h2>
                    <div className="metafooter">
                      <div className="tagColor1 c1">landscaping</div>
                      <div className="wrapfooter">
                        <span className="meta-footer-thumb">
                          <img loading="lazy"
                            className="author-thumb"
                            src={imgLogo}
                            alt="BUR-HAN"
                          />
                        </span>
                        <span className="author-meta">
                          <span className="post-name">By The Bur-Han Team</span>
                          <br />
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </div>
  );
}
